import get from 'lodash/get';
import axiosClient from './axiosClient';
import { apiPath } from '../../utils/api-contants';
import { FactoryDataRequestPayloadTypes } from '../models/factory-management';
import axiosClientFiles from './axiosClientFiles';

const MaintenanceManagementService = {
  getAllActivities: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/checklists`, { params: payload });
      const res: any = get(apiResponse, 'data', []);
      return {
        status: 'success',
        code: res.status,
        res: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getActivityById: async (activityId: string) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/checklist/${activityId}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addActivity: async (payload: any) => {
    try {
      // const myHeaders = new Headers();
      // const oidcUserData = sessionStorage.getItem(
      //   `oidc.user:${process.env.REACT_APP_OIDC_AUTHORIY}:${process.env.REACT_APP_OIDC_CLIENT_ID}`
      // );
      // const token = oidcUserData ? get(JSON.parse(oidcUserData), 'access_token', '') : '';
      // myHeaders.append('Authorization', `Bearer ${token}`);

      // const requestOptions = {
      //   method: 'POST',
      //   headers: myHeaders,
      //   body: payload,
      // };
      // fetch('http://host.docker.internal:9080/api/v1/maintenance/checklist', requestOptions)
      //   .then((response) => response.text())
      //   .then((result) => console.log(result))
      //   .catch((error) => console.error(error));

      const apiResponse = await axiosClientFiles.post(`${apiPath.MAINTENANCE}/checklist`, payload);
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        res: get(error, 'response.data.error'),
      };
    }
  },
  updateActivity: async (payload: any) => {
    const activityId = payload.get('checklist_id');
    payload.delete('checklist_id');
    try {
      const apiResponse = await axiosClientFiles.patch(`${apiPath.MAINTENANCE}/checklist/${activityId}`, payload);
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        res: get(error, 'response.data.error'),
      };
    }
  },
  deleteActivity: async (activityId: string) => {
    try {
      const apiResponse: any = await axiosClient.delete(`${apiPath.MAINTENANCE}/checklist/${activityId}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response?.data?.error,
      };
    }
  },
  updateAcitivity: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.post(apiPath.SITE_FACTORY_MANAGEMENT_URL, payload);
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getMaintenacePlan: async (payload: any) => {
    try {
      //api/v1/maintenance/plans?mt_fiter&user_fiter&page&limit&search_item&field&sort
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/plans`, { params: payload });
      const res: any = get(apiResponse, 'data', []);
      // const res: any = {
      //   status: 'success',
      //   data: [
      //     {
      //       id: 1,
      //       maintenance_name: 'Maintenance 1',
      //       onto_manage_id: 'Pune',
      //       last_maintenance: '7 Oct 2024',
      //       next_maintenance: '9 Oct 2024',
      //       enabled: 'Enabled',
      //       status: 'overdue',
      //       assign: 'Abhilash T',
      //     },
      //     {
      //       id: 2,
      //       maintenance_name: 'Maintenance 2',
      //       onto_manage_id: 'Pune',
      //       last_maintenance: '10 Oct 2024',
      //       next_maintenance: '20 Oct 2024',
      //       enabled: 'Enabled',
      //       status: 'due',
      //       assign: 'Abhilash T',
      //     },
      //     {
      //       id: 3,
      //       maintenance_name: 'Maintenance 3',
      //       onto_manage_id: 'Pune',
      //       last_maintenance: '1 Oct 2024',
      //       next_maintenance: '11 Oct 2024',
      //       enabled: 'Enabled',
      //       status: 'in_progress',
      //       assign: 'Abhilash T',
      //     },
      //   ],
      // };
      return {
        status: 'success',
        code: 200,
        res: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  getMaintenacePlanById: async (planId: string) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/plan/${planId}`);
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  addMaintenacePlan: async (payload: any) => {
    try {
      const apiResponse = await axiosClientFiles.post(`${apiPath.MAINTENANCE}/plan`, payload);
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response?.data?.error,
      };
    }
  },
  updateMaintenacePlan: async (payload: any) => {
    const maintenanceId = payload.get('maintenance_id');
    payload.delete('maintenance_id');
    try {
      const apiResponse = await axiosClientFiles.patch(`${apiPath.MAINTENANCE}/plan/${maintenanceId}`, payload);
      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        error: get(error, 'response.data.error', 'Something went wrong!'),
      };
    }
  },
  deleteMaintenancePlan: async (payload: any) => {
    const { mt_id, preference, current_task_date, next_date, last_date } = payload;
    try {
      const apiResponse: any = await axiosClient.delete(
        `${apiPath.MAINTENANCE}/plan/${mt_id}?preference=${preference}&next_date=${next_date}&last_date=${last_date}&current_task_date=${current_task_date}`
      );
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        error: get(error, 'response.data.message', 'Something went wrong!'),
      };
    }
  },
  getMaintenanceHistory: async (params: any) => {
    const { maintId, ...other } = params;
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/plan/history/${maintId}`, { params: other });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: res.status,
        res: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },

  getActivityHistory : async(params: any) => {
    const { maintId, taskId, ...other } = params;
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/plan/history/${maintId}/${taskId}`, { params: other });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: 200,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  downloadDocument: async (payload: any) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.MAINTENANCE}/documents`, { params: payload });
      const downloadLink = document.createElement('a');
      downloadLink.href = apiResponse.data.url;
      // downloadLink.download = 'example.txt';
      document.body.appendChild(downloadLink);
      downloadLink.click();

      return {
        status: 'success',
        code: apiResponse.status,
        res: apiResponse.data,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  fetchEngineersList: async (payload?: any) => {
    try {
      const apiResponse = await axiosClient.get(`${apiPath.USER_SERVICE_BASE_URL}/maintenance_engineers`, {
        params: payload,
      });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  viewAllMaintenancePlan: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/tasks`, { params: payload });
      const res: any = get(apiResponse, 'data', []);
      return {
        status: 'success',
        code: 200,
        res: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
  checkMachineOntology: async (payload: any) => {
    try {
      const apiResponse: any = await axiosClient.get(`${apiPath.MAINTENANCE}/machines/ontology`, { params: payload });
      const res: any = apiResponse.data;
      return {
        status: 'success',
        code: apiResponse?.status,
        data: res,
      };
    } catch (error: any) {
      return {
        status: 'error',
        code: error?.response?.status,
        data: error?.response,
      };
    }
  },
};

export default MaintenanceManagementService;
